








import { NotificationType } from "@/types/notification";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ButtonCard extends Vue {
  @Prop({ required: true })
  ariaLabel!: string;

  @Prop({ required: false, default: false })
  isDisabled!: boolean;

  @Prop({ required: false, default: NotificationType.DEFAULT })
  issueType!: NotificationType;

  click() {
    this.$emit("clicked");
  }
}
